import {
  Menu,
  MenuButton,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Spinner,
} from "@fluentui/react-components";
import {
  bundleIcon,
  MoreVerticalFilled,
  MoreVerticalRegular,
} from "@fluentui/react-icons";
import React from "react";
import { useStyles } from "./OverflowMenu.styles";

export type OverflowMenuProps = {
  children?: React.ReactNode;
  spinnerLabel?: string;
  tabIndex?: number;
};

const OverflowMenuIcon = bundleIcon(MoreVerticalFilled, MoreVerticalRegular);

export const OverflowMenu: React.FC<OverflowMenuProps> = ({
  children,
  spinnerLabel,
  tabIndex,
}) => {
  const styles = useStyles();
  const handleMenuButtonClick = React.useCallback((e: React.MouseEvent) => {
    e.stopPropagation(); // if user clicks on the overflow menu button, we don't want to trigger prompt card's onClick
  }, []);

  if (spinnerLabel) {
    return (
      <Spinner
        size="tiny"
        labelPosition="after"
        label={spinnerLabel}
        className={styles.spinner}
      />
    );
  }

  // filter out null or undefined menu items
  const menuItems = React.Children.toArray(children).filter(Boolean);
  if (menuItems.length === 0) {
    return null;
  }

  return (
    <Menu>
      <MenuTrigger>
        <MenuButton
          onClick={handleMenuButtonClick}
          appearance="subtle"
          data-testid="overflow-menu-button"
          icon={<OverflowMenuIcon className={styles.overflowMenuIcon} />}
          tabIndex={tabIndex ?? 0}
          className={styles.overflowMenuButton}
        />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>{menuItems}</MenuList>
      </MenuPopover>
    </Menu>
  );
};
